<template>
  <div class="hero is-white is-medium">
    <div class="hero-body">
      <div class="container">
        <br />
        <div class="columns is-centered is-variable is-1-mobile is-8-tablet">
          <div class="column is-7">
            <h1 class="subtitle is-1 is-size-2-touch has-text-centered is-300">¿qué es <span class="is-700">ciudades comunes</span>?</h1>
            <div class="content has-text-centered">
                <p><b>Ciudades Comunes</b> es un proyecto de colaboración entre personas de diferentes organizaciones para repensar la co-construcción de la ciudad. </p>
                <p>Tiene por objetivo hacer ciudades más equitativas, solidarias y participativas a través de la empatía, la escucha y la experimentación con herramientas fisico-digitales. </p>
                <p>Busca acompañar y generar propuestas que pongan en el centro la vida para construir un nuevo sentido común que permita repensar de una manera más justa las ciudades del mañana y su entramado social</p>
            </div>
            <br>
            <img src="@/assets/img/cc-icon-color.png" class="image is-centered" width="80" style="border-radius: 500px;" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.hero.is-custom {
  background-color: #8cc63f;
}
</style>